import React from 'react';
import classnames from 'classnames';
import Card from '../Card';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportHightlightVO } from '@gp/types/dpsReport/v2';

interface IPanelBodyProps extends IBaseProps {
  list: IDPSReportHightlightVO[];
}

const PanelBody: React.FC<IPanelBodyProps> = (props) => {
  const { style, className, list } = props;

  const isNoData = !(list?.length > 0);

  return (
    <div style={style} className={classnames('dbg-dps-report-hightlights-panel-body', className)}>
      {isNoData && <div className="dbg-dps-report-hightlights-panel-body__no-data">No Data</div>}
      {isNoData || (
        <ul className="dbg-dps-report-hightlights-panel-body__list">
          {list?.map((item) => {
            const { mock_id: mockId } = item || {};
            return (
              <li key={mockId} className="dbg-dps-report-hightlights-panel-body__item">
                <Card data={item} />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default PanelBody;
